import { z } from "zod";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedMessages.errors.";

const genericSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const automationReceivedMessagesSchema = z.object({
  id: z.string().optional(),
  returnDays: z.string().optional(),
  enable: z.boolean(),
  showAppAndOnlineCalendar: z.boolean(),
  calendarClassification: z.array(genericSchema).optional(),
  calendarPreferences: z.array(genericSchema).optional(),
  calendarConsultationGroupingRegister: z.array(genericSchema).optional(),
  calendarSpecialties: z.array(genericSchema).optional(),
  calendars: z.array(genericSchema).optional(),
});

export type TAutomationReceivedMessagesForm = z.infer<
  typeof automationReceivedMessagesSchema
>;
